import React from "react";

type CompanyIconProps = {
  width: string;
  height: string;
};

export const CompanyIcon: React.FC<CompanyIconProps> = ({ height, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 95.308 80"
    >
      <defs>
        <style>{`.a,.c{fill:#fff;}.a,.d{stroke:#3f3d56;}.b{fill:#3f3d56;}.d,.g{fill:none;}.e{fill:#fa5a00;}.f,.h{stroke:none;}.h{fill:#fff;}`}</style>
      </defs>
      <g transform="translate(-782 -393)">
        <g className="a" transform="translate(782 393)">
          <circle className="f" cx="40" cy="40" r="40" />
          <circle className="g" cx="40" cy="40" r="39.5" />
        </g>
        <g transform="translate(35.447 9.009)">
          <g className="a" transform="translate(763.552 404.991)">
            <path
              className="f"
              d="M2,0H19a2,2,0,0,1,2,2V38a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
            />
            <path
              className="g"
              d="M2,.5H19A1.5,1.5,0,0,1,20.5,2V37a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,37V2A1.5,1.5,0,0,1,2,.5Z"
            />
          </g>
          <path
            className="b"
            d="M2,0H27a2,2,0,0,1,2,2V38a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z"
            transform="translate(780.552 404.991)"
          />
          <path
            className="c"
            d="M1,0H8A1,1,0,0,1,9,1V11a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1A1,1,0,0,1,1,0Z"
            transform="translate(790.552 431.991)"
          />
          <rect
            className="c"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(786.552 412.122)"
          />
          <rect
            className="c"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(786.552 421.617)"
          />
          <rect
            className="c"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(797.234 412.122)"
          />
          <rect
            className="c"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(797.234 421.617)"
          />
          <rect
            className="a"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(769.935 410.935)"
          />
          <rect
            className="a"
            width="5.935"
            height="4.946"
            rx="1"
            transform="translate(769.935 420.43)"
          />
        </g>
        <path
          className="d"
          d="M-11419.8,5518.862h69.718"
          transform="translate(12207.305 -5067.362)"
        />
        <g className="e" transform="translate(327.898 181.655)">
          <path
            className="f"
            d="M 525.6921997070312 275.0366516113281 L 525.682373046875 275.03662109375 L 525.67333984375 275.03662109375 C 524.475341796875 275.0366516113281 523.2877197265625 274.6409301757812 522.3292846679688 273.9223937988281 L 522.284912109375 273.8890991210938 L 522.279052734375 273.8847351074219 L 522.2732543945312 273.8802795410156 L 513.0400390625 266.8109741210938 C 510.5876159667969 264.9319152832031 510.1212158203125 261.4085998535156 511.9999389648438 258.9566040039062 C 513.06884765625 257.5615539550781 514.6907958984375 256.761474609375 516.4498291015625 256.761474609375 C 517.6903076171875 256.761474609375 518.8674926757812 257.1610107421875 519.8540649414062 257.9169311523438 L 524.6447143554688 261.59033203125 L 537.8650512695312 244.3490753173828 C 538.9338989257812 242.955078125 540.5553588867188 242.1555480957031 542.3136596679688 242.1555480957031 C 543.042724609375 242.1555480957031 543.749755859375 242.2934875488281 544.4091796875 242.5606994628906 L 544.5324096679688 242.3999481201172 L 545.71533203125 243.3090515136719 C 545.7166748046875 243.3101043701172 545.7181396484375 243.3112335205078 545.7195434570312 243.3122863769531 L 546.88720703125 244.2076873779297 L 546.7698974609375 244.3668823242188 C 548.258544921875 246.3273773193359 548.32470703125 249.1211853027344 546.7596435546875 251.1670989990234 L 530.1347045898438 272.8484802246094 C 529.0795288085938 274.2194213867188 527.41943359375 275.0366516113281 525.6921997070312 275.0366516113281 Z"
          />
          <path
            className="h"
            d="M 525.6921997070312 273.5366516113281 C 526.9656982421875 273.5366516113281 528.1673583984375 272.9452819824219 528.9443359375 271.9357299804688 L 545.5682373046875 250.2557220458984 C 546.944091796875 248.4571685791016 546.6044921875 245.88427734375 544.8090209960938 244.5043487548828 L 544.7188720703125 244.6219177246094 L 544.8067626953125 244.5026092529297 C 543.009033203125 243.1240386962891 540.4338989257812 243.4638977050781 539.055419921875 245.2618255615234 L 524.9223022460938 263.6934204101562 L 518.9417724609375 259.1076049804688 C 517.143310546875 257.7295837402344 514.5685424804688 258.070556640625 513.1906127929688 259.868896484375 C 511.812744140625 261.667236328125 512.153564453125 264.2420654296875 513.951904296875 265.6199645996094 L 523.22900390625 272.7221984863281 C 523.9342651367188 273.2509155273438 524.7918701171875 273.53662109375 525.67333984375 273.53662109375 C 525.6795043945312 273.5366516113281 525.6858520507812 273.53662109375 525.6921997070312 273.5366516113281 M 525.6921997070312 276.5366516113281 L 525.67333984375 276.53662109375 C 524.1530151367188 276.53662109375 522.6458740234375 276.0344543457031 521.4295043945312 275.1225891113281 L 521.3613891601562 275.0712585449219 L 512.128173828125 268.001953125 C 509.018798828125 265.6195373535156 508.4275207519531 261.1528625488281 510.8092346191406 258.0443115234375 C 512.1643676757812 256.2757568359375 514.2202758789062 255.2614593505859 516.4498291015625 255.2614593505859 C 518.0230712890625 255.2614593505859 519.5156860351562 255.7679748535156 520.766357421875 256.7262573242188 L 524.3671264648438 259.4872436523438 L 536.6747436523438 243.4363403320312 C 538.0296630859375 241.6691436767578 540.0850219726562 240.6555480957031 542.3136596679688 240.6555480957031 C 542.83740234375 240.6555480957031 543.352294921875 240.7117004394531 543.8521728515625 240.8219299316406 L 544.255859375 240.2955169677734 L 546.6273193359375 242.1181793212891 C 546.6290283203125 242.1194610595703 546.630615234375 242.1206817626953 546.63232421875 242.1219787597656 L 548.9675903320312 243.9127502441406 L 548.5845947265625 244.4326477050781 C 549.8397216796875 246.811279296875 549.687744140625 249.8081817626953 547.9509887695312 252.0784759521484 L 531.32177734375 273.7654724121094 C 530.6619262695312 274.6228332519531 529.800048828125 275.3285522460938 528.829345703125 275.8063659667969 C 527.8587646484375 276.2841186523438 526.77392578125 276.5366516113281 525.6921997070312 276.5366516113281 Z"
          />
        </g>
      </g>
    </svg>
  );
};
